import {Component} from '@angular/core';
import {ViewController} from "ionic-angular";
import {GlobalProvider} from "../../providers/global/global";

/**
 * Generated class for the PopoverAddContactComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'popover-add-contact',
  templateUrl: 'popover-add-contact.html'
})
export class PopoverAddContactComponent {

  public isBrowser: boolean = false

  constructor(private viewCtrl: ViewController, private globalProvider: GlobalProvider) {
    console.log('Hello PopoverAddContactComponent Component');
    this.isBrowser = this.globalProvider.isBrowser();
  }

  public close(type): void {
    this.viewCtrl.dismiss({type: type});
  }

  public changeListener($event) : void {
    this.viewCtrl.dismiss({type: 'vcard', file: $event.target.files[0]});
  }

}



// WEBPACK FOOTER //
// ./src/components/popover-add-contact/popover-add-contact.ts